import React, { FC, ReactNode } from 'react';

type TableItemProps = {
  title: string;
  value: string | ReactNode;
};

export const TableItem: FC<TableItemProps> = ({ title, value }) => (
  <div className='table-item d-flex flex-column flex-md-row'>
    <div className='table-item__title col-md-4 p-0 align-self-start'>{title}</div>
    <div className='table-item__value'>{value}</div>
  </div>
);
